import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { urlFor, client } from '../../utilities/index'

import './About.scss'
import wrapper from '../../utilities/Wrapper'
import motionWrapper from '../../utilities/MotionWrapper'

const About = () => {
  const [abouts, setAbouts] = useState([])

  useEffect(() => {
    const query = '*[_type=="abouts"]'

    client.fetch(query).then(data => setAbouts(data))
  }, [])

  return (
    <>
      <h2 className='head-text dark:text-gray-200'>
        I Know that <span className='dark:text-blue-400'>Good Dev</span> <br />
        means <span className='dark:text-blue-400'>Good Business</span>
      </h2>

      <div className='app__profiles'>
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            whileHover={{ scale: 1.1, boxShadow: [0, 0, 0, 1, '#000'] }}
            transition={{ duration: 0.5, type: 'tween' }}
            className='app__profile-item'
            key={`${about.title} ${index}}`}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className='bold-text dark:text-white' style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p
              className='p-text dark:text-slate-400'
              style={{ marginTop: 10 }}
              title={about.description}
            >
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  )
}

export default wrapper(
  motionWrapper(About, 'app__about'),
  'about',
  'app__whitebg dark:bg-black'
)
